import { baseApi } from 'services'

export const timezonesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTimezones: builder.query<any, void | boolean>({
      query: () => `timezones`,
    }),
  }),
})

export const { useGetTimezonesQuery } = timezonesApi
